import { useResource, useResources } from 'datx-jsonapi-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { RelatedLectureDesktop } from '@/components/ui/features/originals/RelatedLecturesSection/components/RealtedLectures.desktop';
import { RelatedLecturesMobile } from '@/components/ui/features/originals/RelatedLecturesSection/components/RelatedLectures.mobile';
import { ViewAllButton } from '@/components/ui/features/originals/RelatedLecturesSection/components/ViewAllButton';
import { OriginalsSection } from '@/components/ui/shared/sections/OriginalsSection/OriginalsSection';
import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import { getOriginalSeries } from '@/queries/originals-series';
import { queryOriginalsLectures } from '@/queries/thin-lectures';

export const RelatedLecturesSection: FC = () => {
  const { t } = useTranslation();
  const { id: seriesId } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });

  const { data: series } = useResource(getOriginalSeries(seriesId));
  const { data, error } = useResources(queryOriginalsLectures(series?.subject?.id));

  if (error) throw error;

  const isEmpty = data?.length === 0;

  if (isEmpty) return null;

  return (
    <OriginalsSection subheading={<ViewAllButton />} title={t('episodeMaterial.relatedLectures')}>
      <RelatedLectureDesktop />
      <RelatedLecturesMobile />
    </OriginalsSection>
  );
};
